import { render, staticRenderFns } from "./SystemTags.vue?vue&type=template&id=bce1d56c&scoped=true&"
import script from "./SystemTags.vue?vue&type=script&lang=js&"
export * from "./SystemTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce1d56c",
  null
  
)

export default component.exports